module.exports = __webpack_public_path__ + "static/media/mofa08@1x.0851af51.png";